import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

var config = {
  apiKey: "AIzaSyAC45NBjwqGWvB5IfdKPi_RvgsxQ07BveE",
  authDomain: "killergame-set.firebaseapp.com",
  databaseURL: "https://killergame-set.firebaseio.com",
  projectId: "killergame-set",
  storageBucket: "killergame-set.appspot.com",
  messagingSenderId: "183369487175",
};

firebase.initializeApp(config);

export default firebase;
